import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserID } from "../Redux/UserSlice";
import { addCart } from "../Redux/CartSlice";
import { v4 as uuidv4 } from 'uuid';
import Loader from "react-js-loader";

const Signup = () => {
  const navigate = useNavigate("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [errormsg, seterrormsg] = useState("");
  const userToggle = useSelector((state) => state.user.userToggle);
  const lastProduct = useSelector((state) => state.LP.product);
  // console.log('lastProduct', lastProduct)


  function validateEmail(email) {
    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return pattern.test(email);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    if (!validateEmail(email)) {
      seterrormsg("Enter a valid email");
      setLoading(false);
      setTimeout(() => {
        seterrormsg('');

      }, 3000)
      return; // Exit the function if the email is not valid
    }




    try {



      const response = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/register", {
        name,
        email,
        password,
      });

      if (response.status === 201) {
        setSuccessMessage(`Signup successful! ${name}, you will be now be logged in.`);

        setName("");
        setEmail("");
        setPassword("");

        setTimeout(() => {
          seterrormsg('');

        }, 3000)
        // Log the user in after successful registration
        const loginResponse = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/login", {
          email,
          password,
        });

        if (loginResponse.status === 200) {
          const foundUserIDResponse = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/FindOneUser", { email: email });
          const foundUserID = foundUserIDResponse.data._id;
          const user = {
            userID: foundUserID,
            name: foundUserIDResponse.data.name,
            email: foundUserIDResponse.data.email,
          };
          dispatch(setUserID(user));

          // If lastProduct exists, save it to the cart
          if (lastProduct && lastProduct.id && lastProduct.productID) {
            const toSaveItem = await axios.post("https://sportsblendserver.netlify.app/.netlify/functions/api/createCart", {
              user_id: foundUserID,
              product_id: lastProduct.productID,
              quantity: lastProduct.quantity,
              name: lastProduct.name,
              number: lastProduct.number,
              size: lastProduct.size,
            });

            dispatch(addCart(lastProduct));


            // navigate(`/productCustomize/${lastProduct.productID}`);

            navigate('/cart', { replace: true }); // Use replace method to navigate
          }
          else {

            // navigate('/home');
            
            navigate('/home', { replace: true }); // Use replace method to navigate
          }

          setLoading(false);

        } else {
          setSuccessMessage("Failed to log in after registration");
          setLoading(false);
        }
      } else {
        setSuccessMessage(response.message);
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      setSuccessMessage("Failed to register user");
      setLoading(false);
    }
  };


  
  const handlebtnSignup = () =>{
    // to="/signup"
 
    navigate('/login', {replace: true})
  }

  return (
    <div className="root">
      <div className="containerleft">
        <h2 className="heading">Create Account!</h2>
        <form className="signup-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {loading ? <Loader type="spinner-default" bgColor={'black'} size={30} /> : (
            <button type="submit">Signup</button>
          )}
        </form>
        <p className="success-message">{successMessage}</p>
        <p className="error-message">{errormsg}</p>
      </div>
      <div className="containerright">
        <div className="content">
          <h2 className="heading">SportsBlend</h2>
          <p className="subheading">
            To continue with us, please login with your personal information
          </p>
          <button type="submit"  onClick={handlebtnSignup}>
            <Link className="linkButton">
              Login
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Signup;
